
import { useExpertFilters } from '../../../hooks/expertListHooks/useExpertFilters'; 
import { useExpertList } from '../../../hooks/expertListHooks/useExpertList';     
import { useFreeConsultationOffer } from '../../../hooks/useFreeConsultationOffer';
import { ExpertWrapper } from '../ExpertWrapper'; 
import { BaseExperts } from '../BaseExperts'; 
import { SupremeExperts } from '../SupremeExperts';
import { FeaturedExperts } from '../FeaturedExperts';
import { FreeConsultationPopup } from '../../subCategories/astrologySubcategories/reusableAstrologyLayout/FreeConsultationPopup';

const Astrology = () => {
  // Lock this page to 'Astrology'
  const { 
    searchTerm, 
    setSearchTerm, 
    sortBy, 
    setSortBy, 
    sortOrder, 
    setSortOrder, 
    minRating, 
    setMinRating, 
    filters 
  } = useExpertFilters('Astrology');
  
  const { baseExperts, supremeExperts, featuredExperts, loading, error } = useExpertList(filters);

  // 🟢 Free Consultation Hook (Conflict-free single trigger)
  const { showPopup, closePopup } = useFreeConsultationOffer();

  // Theme configuration matching the Astrology category
  const astrologyTheme = {
    primaryColor: "text-amber-600",
    buttonBg: "bg-amber-500",
    buttonHoverBg: "hover:bg-amber-600",
  };

  const handleStartConsultation = () => {
    closePopup();
    window.scrollTo({ top: 300, behavior: 'smooth' });
  };

  return (
    <>
      <ExpertWrapper
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        activeCategory="Astrology"
        loading={loading} // Keeps the wrapper loading state
        error={error}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        minRating={minRating}
        setMinRating={setMinRating}
      >
        <BaseExperts 
          experts={baseExperts} 
          title="All Astrologers" 
          loading={loading} 
          error={!!error} 
        />
        <SupremeExperts 
          experts={supremeExperts} 
          title="Supreme Astrologers" 
          loading={loading} 
          error={!!error} 
        />
        <FeaturedExperts 
          experts={featuredExperts} 
          title="Featured Astrologers" 
          loading={loading} 
          error={!!error} 
        />
      </ExpertWrapper>

      {/* 🎁 Free Consultation Popup */}
      <FreeConsultationPopup
        isOpen={showPopup}
        onClose={closePopup}
        onStart={handleStartConsultation}
        theme={astrologyTheme}
      />
    </>
  );
};

export default Astrology;